export const TITLE = "[DEV] DemBeck Coding";
export const MAPS_API_KEY = "AIzaSyBRaiMQl0s438GAw20YUdAP-cI9BIOrll8";
export const APP_NAME = "[DEV] DemBeck Coding";
export const BUBBLE_TIME_MS = 2000;
export const CHART_THEME = "dark2"
